import { jsxs as t, jsx as o } from "react/jsx-runtime";
import d from "react";
import n from "styled-components";
const g = n.div.withConfig({
  displayName: "RangoLoading",
  componentId: "sc-15qq1on-0"
})(["position:relative;display:flex;align-items:center;justify-content:center;gap:var(--spacing-1x);"]), r = n.span.withConfig({
  displayName: "LoadingDot",
  componentId: "sc-15qq1on-1"
})(["width:var(--size-1x);height:var(--size-1x);border-radius:var(--border-radius-circular);background-color:var(--color-grey-50);", " &:nth-child(1){animation-delay:0s;}&:nth-child(2){animation-delay:calc(var(--duration-moderate-01) * 1);}&:nth-child(3){animation-delay:calc(var(--duration-moderate-01) * 2);}@keyframes dsaas-loading{0%{background-color:var(--color-green-500);}50%{background-color:var(--color-green-600);}100%{background-color:var(--color-green-800);}}@keyframes dsaas-loading-inverse{0%{background-color:rgb( var(--color-grey-0-rgb) / var(--opacity-super-high) );}50%{background-color:rgb(var(--color-grey-0-rgb) / var(--opacity-high));}100%{background-color:rgb(var(--color-grey-0-rgb) / var(--opacity-low));}}"], ({
  $inverse: a
}) => a ? "animation: dsaas-loading-inverse var(--duration-slow-02) linear infinite alternate;" : "animation: dsaas-loading var(--duration-slow-02) linear infinite alternate;"), c = d.forwardRef(({
  inverse: a = !1,
  ...i
}, e) => /* @__PURE__ */ t(g, { ref: e, "data-testid": "rango-loading", "data-rango-component": "rango-loading", "data-is-rango": !0, ...i, children: [
  /* @__PURE__ */ o(r, { $inverse: a }),
  /* @__PURE__ */ o(r, { $inverse: a }),
  /* @__PURE__ */ o(r, { $inverse: a })
] }));
c.displayName = "RangoLoading";
export {
  c as RangoLoading
};
